/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    ApartmentOutlined,
    BadgeOutlined,
    Email,
    Flag,
    PhoneAndroidOutlined,
    ReceiptLongOutlined,
    SignpostOutlined
} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Pedido_Factura = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid2 container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Estado'}
                                  dato={'estado'} {...props} editable={false}

                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'}
                                  dato={'nombre'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'}
                                  dato={'cc'} {...props}

                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'}
                                  dato={'celular'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Email} nombre={'Correo'}
                                  dato={'correo'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Ciudad'}
                                  dato={'ciudad'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Otro'}
                                  dato={'otraCiudad'} {...props}
                    />
                </Grid2>

                <Grid2 container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Direccion'}
                                  dato={'direccion'} {...props}
                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de Factura</Typography>
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoTexto Icono={ReceiptLongOutlined} nombre={'Numero de Factura'}
                                  dato={'numFactura'} {...props}
                    />
                </Grid2>

                <Grid2 container size={6}>
                    <IngresoFecha Icono={ReceiptLongOutlined} nombre={'Fecha de Factura'}
                                  dato={'fechaFactura'} {...props}
                    />
                </Grid2>


                <Grid2 container size={12} sx={{mt: 4}}>
                    <IngresoTexto lineas={4} nombre={'Notas Internas'}
                                  dato={'notas'} {...props}
                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Pedido_Factura